(() => {
  if (window.koDirectoryReady) return;
  window.koDirectoryReady = true;
  const normalize = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss');
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-ko-team-search]')) return;
    const directory = event.target.closest('[data-ko-directory]');
    const query = normalize(event.target.value.trim());
    let count = 0;
    directory.querySelectorAll('[data-ko-team-name]').forEach(card => {
      card.hidden = !normalize(card.dataset.koTeamName).includes(query);
      if (!card.hidden) count++;
    });
    directory.querySelector('[data-ko-team-count]').textContent = `${count} Teams`;
    directory.querySelector('[data-ko-team-empty]').hidden = count > 0;
  });
})();
